import { TranslateService } from "@ngx-translate/core";
import { AccountService } from "src/app/services/account.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { Account } from "../client-data";
import * as moment from "moment";
import { UrlConstants } from "src/app/models/urlConstants";
import { ApiService } from "src/app/services/api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { ClientInvoicesFilterModel } from "src/app/models/clientInvoices";

@Component({
  selector: "app-invoice",
  templateUrl: "./invoice.component.html",
  styleUrls: ["./invoice.component.scss"],
})
export class InvoiceComponent implements OnInit {
  today = new Date();
  selectedInvoice: any;
  invoices: any[];
  dateFrom: Date = new Date(this.today.setMonth(this.today.getMonth() - 1));
  dateTo: Date = new Date();
  selectedClient: any;
  accList: Object;
  isReportArabic: boolean = true;
  isInvoicesLoading = false;
  filter:ClientInvoicesFilterModel 
  mainCode:number;
  subCode:number;
  isArabic: boolean;

  tryGenerate(invoice) {

    let filter = {
      invoiceIDs: [invoice.InvoiceID],
      invoiceType: "invoices",
      isArabic: this.isReportArabic,
      take: 1
    }

    localStorage.setItem('reportFilter', JSON.stringify(filter))
    const routePath = this.router.serializeUrl(this.router.createUrlTree(['/generic-report/' + 'RptInvoice' + '/' + '0'], { queryParams: { hideNavbar: true } }))
    const url = window.location.origin + this.location.prepareExternalUrl(routePath)
    window.open(url, '_blank')
  }

  selectInvoice(invoicee) {
    this.selectedInvoice = invoicee;
  }

  constructor(
    private http: HttpClient,
    private accService: AccountService,
    public translate: TranslateService,
    private apiService: ApiService,
    private router: Router,
    private location: Location
  ) {
    this.isArabic =this.translate.currentLang === "ar";
    this.accList = JSON.parse(localStorage.getItem("accList")) as Account[];
    this.selectedClient = this.accList[0].relationCode;


  }

  // fetchClientInvoices() {
  //   let from = moment(this.dateFrom).format("YYYY/MM/DD");
  //   let to = moment(this.dateTo).format("YYYY/MM/DD");

  //   // 01-03-2020
  //   return this.http.get<any[]>(
  //     `${UrlConstants.backofficeUrl}/api/Invoice/getClientInvoice?fromDate=${from}&toDate=${to}&lang=1&relationCode=${this.selectedClient}`
  //   );
  // }
    fetchClientInvoices() {
      let from = moment(this.dateFrom).format("YYYY/MM/DD");
      let to = moment(this.dateTo).format("YYYY/MM/DD");
       this.filter={
        mainCode:this.mainCode,
        subCode:this.subCode,
        from:this.dateFrom,
        to:this.dateTo,
        relationCode:this.selectedClient,
        isPosted:true
      } 
      // 01-03-2020
      return this.http.post<any[]>(
        `${UrlConstants.backofficeUrl}/api/Invoice/getClientInvoices`,this.filter
      );
    }
  
  public maxDate: Date = new Date();

  public disableFutureDates = (d: Date | null): boolean => {
    if (!d) return true;
    const today = new Date();
    const date = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const max = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    return date <= max;
  };
  onSelectClient(event) {}

  onDateChange() {
    this.isInvoicesLoading = true;
    this.fetchClientInvoices().subscribe((res) => {
      this.invoices = res;
      this.isInvoicesLoading = false;
    });
  }
  fetchDefaultAccount()
  {
        this.accList = JSON.parse(localStorage.getItem("accList")) as Account[];
        this.selectedClient = this.accList[0].relationCode;
        this.mainCode = this.accList[0].MainCode;
        this.subCode = this.accList[0].SubCode;
  }
  ngOnInit(): void {
          this.fetchDefaultAccount();
              this.isInvoicesLoading = true;
    this.fetchClientInvoices().subscribe((res) => {
      this.invoices = res;

      this.isInvoicesLoading = false;
    });

  }
}
